export const RESOURCE_STATUS_LABELS: Record<string, string> = {
  draft: "черновик",
  on_moderation: "на модерации",
  approved: "одобрен",
  active: "активен",
  paused: "на паузе",
  finished: "завершён",
  rejected: "отклонен",
  disabled: "выключен",
};

export const RESOURCE_TYPE_LABELS: Record<string, string> = {
  channel_public: "канал",
  channel_private: "канал",
  chat_public: "чат",
  chat_private: "чат",
  bot: "бот",
};

export const TARGET_ACTION_LABELS: Record<string, string> = {
  subscribe: "подписка",
  join_request: "поданная заявка",
  join_confirmed: "заявка и подтверждённое вступление",
  start_bot: "запуск бота",
};

export const BOT_LAUNCH_MODE_LABELS: Record<string, string> = {
  start: "запуск /start",
  unique_start: "запуск /start уникального пользователя",
};

export const VERIFICATION_MODE_LABELS: Record<string, string> = {
  verified: "с проверкой",
  no_check: "без проверки",
};

export const FINANCE_STATUS_LABELS: Record<string, string> = {
  pending: "ожидает",
  approved: "одобрено",
  completed: "завершено",
  cancelled: "отменено",
  rejected: "отклонено",
  failed: "ошибка",
  expired: "истёк",
};

export const FINANCE_METHOD_LABELS: Record<string, string> = {
  crypto_check: "чек cryptobot",
  crypto_transfer: "USDT на адрес",
  support: "через менеджера",
  invoice: "перевод USDT cryptobot",
  check: "чек cryptobot",
};

export function labelFrom(map: Record<string, string>, value: string | null | undefined): string {
  if (!value) return "-";
  return map[value] ?? value.replaceAll("_", " ");
}
